export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";